/** @format */

import { request } from 'src/utils'

// eslint-disable-next-line import/no-anonymous-default-export
export const API = {
  getPromethuesInstance: '/monitor/?Action=ListPrometheusInstances&Version=2025-01-01',
  createPrometheusInstance: '/monitor/?Action=CreatePrometheusInstance&Version=2025-01-01',
  getPrometheusInstanceToken: '/monitor/?Action=GetPrometheusToken&Version=2025-01-01'
}

// 获取
export const getPromethuesInstance = async (params?: any) => {
  const result = await request(API.getPromethuesInstance, {
    data: params || {},
    method: 'GET'
  })
  return result?.data || {}
}

// 创建
export const createPrometheusInstance = async (region: string) => {
  const result = await request(API.createPrometheusInstance, {
    data: {
      Region: region
    },
    method: 'POST'
  })
  return result?.data || {}
}

// 获取Token
export const getPrometheusInstanceToken = async (ControllerID: string) => {
  const result = await request(API.getPrometheusInstanceToken, {
    data: {
      ControllerID
    },
    method: 'GET'
  })
  return result?.data || {}
}
